"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCommerceSFRAAPI = exports.SFRAAPIProvider = exports.SFRAAPIContext = void 0;
var _react = require("react");
/**
 * Provider and associated hook for accessing the Commerce API in React components.
 */
// @ts-ignore
const SFRAAPIContext = exports.SFRAAPIContext = /*#__PURE__*/(0, _react.createContext)();
const SFRAAPIProvider = exports.SFRAAPIProvider = SFRAAPIContext.Provider;
const useCommerceSFRAAPI = () => (0, _react.useContext)(SFRAAPIContext);
exports.useCommerceSFRAAPI = useCommerceSFRAAPI;